import React, { useState, useContext } from "react";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  addActiveFn,
  pushToParams,
  withNewTitleAndName,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import DemandUpdate from "./demand-update/DemandUpdate";
import { formatListWithParameter, formatShortDate, truncateText } from "../../utils";
import request from "../../services/request";
import { useTranslation } from "react-i18next";
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import { Field } from "formik";
import Select from "../../components/form-fields/Select"; /* Added Line */
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import TextInput from "../../components/form-fields/TextInput";
import { ThemeContext } from '../../../context/ThemeContext';


export default function ContinuingDemands(props) {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [returnReason, setReturnReason] = useState("");
  const [t, i18n] = useTranslation(); /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [filters, setFilters] = useState([]);
  const [configData, setConfigData] = useState(null);

  const ikiliFormat = new URLSearchParams(props.location.search).get('ikiliFormat');
  const surecDevamEdiyor = new URLSearchParams(props.location.search).get('surecDevamEdiyor');


  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onReject = () => {
    request({
      url: "atanan-talep/iade-et",
      method: "POST",
      data: {
        body: {
          id: selectedRow.id,
          iadeNedeni: returnReason,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setRefreshList(!refreshList);
        setShowModal(false);
      }
    });
  };
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };
  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="raporlar/config"
                    // configParameterName="talepTurId"
                    // configParameterValue={16}
                    // configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    {/* <Field
                      name="filtreTuru"
                      label={`${t("demandUpdate.talepFiltrele")}`}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.filtreTurleri}
                    /> */}
                    {/* <Field
                      name="groupID"
                      label={t("davaIcraSavcilik.grup")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.grupSirketleri}
                    /> */}
                    <Field
                        name="yurtici"
                        label={t("demandList.yurtici")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.yurtici}
                    />
                    <Field
                        name="sirketDurumu"
                        label={t("demandList.sirketDurumu")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.sirketDurumu}
                    />
                    <Field
                        name="isSubsidiary"
                        label={t("demandList.istirakSirketleri")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.isSubsidiary}
                        // onChangeFunc={(opt) => setIsSubsidiary(opt)}
                    />
                    <Field
                      name="sirketID"
                      label={t("davaIcraSavcilik.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.sirketler}
                    />

                    <Field
                      name="islemNo"
                      label={t("davaIcraSavcilik.islemNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    {/* <Field
                      name="dosyaNo"
                      label={t("documentUpdate.dosyaNo")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    {/* <Field
                      name="departmanID"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.departmanlar}
                    /> */}
                    {/* <Field
                      name="dosyaTuruID"
                      label={t("davaIcraSavcilik.dosyaTuru")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.dosyaTurleri}
                    /> */}
                    <Field
                      name="talepTuruID"
                      label={t("demandTypes.talepTürü")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepTurleri}
                    />
                    {/* <Field
                      name="talepDurumuID"
                      label={t("demandStates.talepDurumu")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.talepDurumu}
                    /> */}

                    {/* <Field
                      name="avukatID"
                      label={t("report.gorevlendirilen")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.users}
                    />
                    <Field
                      name="dilID"
                      label={t("sozlesmeler.dil")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.diller}
                    /> */}
                    
                    <Field
                      name="konu"
                      label={t("davaIcraSavcilik.konu")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="isGucuBirimId"
                      label={t("demandUpdate.isGucuBirim")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.isGucu}
                    />
                    <Field
                      name="createdUser"
                      label={t("demandList.ekleyen")}
                      colNumber="3"
                      component={TextInput}
                    />
                    {/* <Field
                      name="talepbilgi"
                      label={t("demandList.talepBilgisi")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    <Field
                      name="acilisTarihiMin"
                      label={t("demandList.baslangicTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                    />
                    {/* <Field
                      name="bitisTarihi"
                      label={t("demandList.bitisTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                    /> */}
                    <Field
                      name="avukatID"
                      label={t("report.gorevlendirilen")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.users}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      {(selectedRow?.talepDurumId === 2) && (
        // DirectedDemands sayfasından alındı
        <DemandUpdate
        extraButton
        extraButtonOnClick={onReject}
        pageType={1}
        extraButtonText={t("actionButtonGenerator.iadeEt")}
        type={3}
        title={t("anaSayfa.yonlendirilmisTalepler")}
        endpoint={"atanan-talep/dosyaya-donustur"}
        endPointUrl2={"atanan-talep/tamamla"}
        endPointUrl3={"atanan-talep/kaydet"}
        endPointUrl4={"atanan-talep/baslat"}
        okButtonText={t(
          selectedRow?.talepTur?.departmentId == 2
            ? "actionButtonGenerator.dosyayaDonustur"
            : "actionButtonGenerator.numaraVer"
        )}
        secondSubmitButttonText={t(
          selectedRow?.talepTur?.departmentId == 2
            ? "actionButtonGenerator.tamamla"
            : "actionButtonGenerator.numaraVermeden"
        )}
        thirdSubmitButttonText={t("actionButtonGenerator.taslak")}
        fourthSubmitButttonText={t("actionButtonGenerator.baslat")}
        refreshList={refreshList}
        setRefreshList={setRefreshList}
        showModal={showModal}
        isUpdating={isUpdating}
        selectedRow={selectedRow}
        setShowModal={setShowModal}
        setReturnReason={setReturnReason}
      />
      )}
      {(selectedRow?.talepDurumId === 3) && (
        // ContinuingDemands sayfasından alındı
        <DemandUpdate
          extraButton
          extraButtonOnClick={onReject}
          extraButtonText={t("actionButtonGenerator.iadeEt")}
          pageType={2}
          type={2}
          title={(surecDevamEdiyor) ? t("anaSayfa.sureciDevamEdenTalepler") : t("anaSayfa.surecDevamEdenTalepler")}
          endpoint={"atanan-talep/dosyaya-donustur"}
          endPointUrl2={"atanan-talep/tamamla"}
          endPointUrl3={"atanan-talep/kaydet"}
          okButtonText={t(
            selectedRow?.talepTur?.departmentId == 2
              ? "actionButtonGenerator.dosyayaDonustur"
              : "actionButtonGenerator.numaraVer"
          )}
          secondSubmitButttonText={t(
            selectedRow?.talepTur?.departmentId == 2
              ? "actionButtonGenerator.tamamla"
              : "actionButtonGenerator.numaraVermeden"
          )}
          thirdSubmitButttonText={t("actionButtonGenerator.taslak")}
          refreshList={refreshList}
          setRefreshList={setRefreshList}
          showModal={showModal}
          isUpdating={isUpdating}
          selectedRow={selectedRow}
          setShowModal={setShowModal}
          setReturnReason={setReturnReason}
        />
      )}
      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""
            endpoint={(surecDevamEdiyor) ? ((ikiliFormat) ? 'surec-devam-ediyor/listele-tumu' : 'surec-devam-ediyor/listele') : ((ikiliFormat) ? 'atanan-talep/listele-basladi-tumu' : 'atanan-talep/listele-basladi')}
            keyField="id"
            refreshList={refreshList}
            hideSelection={true}
            customBody={{
              filters: filters,
            }}
            columns={[
              {
                dataField: "id",
                text: `${t("demandList.islemNo")}`,
                sort: true,
                headerStyle: {
                  width: 64
                }
              },
              // {
              //   dataField: "companyGroup",
              //   text: `${t("demandList.grup")}`,
              //   formatter: (data) => formatListWithParameter(data, "name"),

              //   sort: true,
              // },
              {
                dataField: "company.name",
                text: `${t("demandList.grupSirketi")}`,
                sort: true,
              },
              {
                dataField: "talepTur.talepTuru",
                text: `${t("demandList.talepTuru")}`,
                sort: true,
              },
              {
                dataField: "talepDurum.talepDurumName",
                text: `${t("demandList.talepDurumu")}`,
                sort: true,
              },

              {
                dataField: "konu",
                text: `${t("demandList.konu")}`,
                formatter: (data) => truncateText(data, 35, 30),
                sort: true,
              },
              /*{
                dataField: "isGucuBirimi.name",
                text: `${t("demandList.isGücüBirim")}`,
                sort: true,
              },*/
              {
                dataField: "avukatName",
                text: `${t("report.gorevlendirilen")}`,
                sort: true,
              },
              {
                dataField: "cdate",
                text: `${t("demandList.talepTarihi")}`,
                formatter: formatShortDate,
                sort: true,
                headerStyle: {
                  width: 80
                }
              },
              {
                dataField: "createdUser.fullName",
                text: `${t("demandList.ekleyen")}`,
                sort: true,
              },
              {
                dataField: "sonDurum.mesaj",
                text: `${t("demandList.sonDurum")}`,
                formatter: (data) => truncateText(data, 35, 30),
                sort: true,
                headerStyle: {
                  width: 120
                }
              },
              {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
              sort: false,
            },
              // {
              //   dataField: "talepbilgi",
              //   text: `${t("demandList.talepBilgisi")}`,
              //   sort: true,
              // },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EXCEL_EXPORT, {
                  requestTo: (surecDevamEdiyor) ? ((ikiliFormat) ? 'file/download-excel-surec-devam-ediyor-tumu': 'file/download-excel-surec-devam-ediyor'):((ikiliFormat) ? 'file/download-excel-baslayan-tumu': 'file/download-excel-baslayan')
                }),
                addActiveFn(
                  pushToParams(
                    withNewTitleAndName(
                      ABT.EDIT,
                      "actionButtonGenerator.goruntule",
                      "EDIT_WITH_TITLE"
                    ),
                    onUpdateButtonClicked
                  ),
                  (row) => !row.departmanYoneticisiMi
                ),
                addActiveFn(
                  pushToParams(ABT.EDIT, onUpdateButtonClicked),
                  (row) => row.departmanYoneticisiMi
                ),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
